import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import OrderDetailPage from '@features/admin/orders/OrderDetailPage.tsx';
import { useAdminOrderDetailStore } from '@features/admin/orders/useAdminOrderDetailStore.ts';

const paramsSchema = z.object({
  orderId: z.coerce.number().positive(),
});

export const Route = createFileRoute('/admin/orders/$orderId')({
  params: {
    parse: v => paramsSchema.parse(v),
  },
  component: RouteComponent,
  beforeLoad: async ({ params }) => {
    const orderId = paramsSchema.parse(params).orderId;
    await useAdminOrderDetailStore.getState().loadOrderDetail(orderId);
  },
});

function RouteComponent() {
  const { orderId } = Route.useParams();
  return <OrderDetailPage orderId={orderId} />;
}
